import { GETTERS, STATE } from "./names";
import { MetaWorldManager } from "~/core/services/map/MetaWorldManager";

export default {
    [GETTERS.PROVIDER]: (state) => state[STATE.PROVIDER] || MetaWorldManager.sharedInstance().ethereum(),
}